import { Observable } from 'rxjs';

import { UserModule } from 'user/user-module';

export abstract class UserModuleRepositoryPort {
	public abstract saveUserModules(
		userModules: UserModule[],
		resetForUserId?: string
	): Promise<void>;

	public abstract observeUserModulesByUserId(
		userId: string
	): Observable<UserModule[]>;

	public abstract addUserModule(userModule: UserModule): Promise<void>;

	public abstract removeUserModule(
		userId: string,
		moduleId: string
	): Promise<void>;

	public abstract findByUserIdAndModuleId(
		userId: string,
		moduleId: string
	): UserModule;
}
